export default __webpack_public_path__ + "static/media/default.0ce51378e1e966a0603b1c9e4f0632f1.png";